import { Component, OnInit, Input, Output, EventEmitter, OnChanges, DoCheck } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { SalesCategoryService } from '../../../service/sales-category/sales-category.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9161',
  templateUrl: './wa9161.component.html',
  styleUrls: ['./wa9161.component.scss']
})
export class Wa9161Component implements OnChanges {
  public componentTitle = 'WA9161:売上分類マスタ登録';
  public salescategoryCd: FormControl;
  public salescategoryTx: FormControl;
  public creditaccCd: FormControl;
  public validation = validation;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;
  private isSubmitButtonEnabled = false;
  constructor(private salescategoryService: SalesCategoryService, private commonService: CommonService, ) {
    (
      this.salescategoryCd = new FormControl('', [
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.code39),
        Validators.maxLength(validation.salescategoryCd.maxLength)
      ])),
      (this.salescategoryTx = new FormControl('', [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.salescategoryTx.maxLength)
      ])),
      (this.creditaccCd = new FormControl('', [
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.code39),
        Validators.maxLength(validation.creditaccCd.maxLength)
      ])),
      (this.containerHeight = window.innerHeight - config.containerheaderMargin);
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onSubmit() {
    var salescategoryCd = this.salescategoryCd.value.trim();
    var salescategoryTx = this.salescategoryTx.value.trim();
    var creditaccCd = this.creditaccCd.value.trim();
    let errors = false;
    if (!this.isSubmitButtonEnabled)
      return;

    if (this.salescategoryCd.errors !== null) {
      this.salescategoryCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.salescategoryTx.errors !== null) {
      this.salescategoryTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.creditaccCd.errors !== null) {
      this.creditaccCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }

    const updprogramCd: string = JSON.parse(sessionStorage.getItem('loginResult'))['user']['userId'];
    this.salescategoryService
      .post(salescategoryCd, salescategoryTx, creditaccCd, updprogramCd)
      .then(outputJson => {
        this.isDelayHide = true;
        this.salescategoryCd = new FormControl('', [
          Validators.pattern(validation.halfBlankOnly),
          Validators.pattern(validation.code39),
          Validators.maxLength(validation.salescategoryCd.maxLength)
        ]);
        this.salescategoryTx = new FormControl('', [
          Validators.pattern(validation.emBlankOnly),
          Validators.pattern(validation.halfBlankOnly),
          Validators.maxLength(validation.salescategoryTx.maxLength)
        ]);
        this.creditaccCd = new FormControl('', [
          Validators.pattern(validation.halfBlankOnly),
          Validators.pattern(validation.code39),
          Validators.maxLength(validation.creditaccCd.maxLength)
        ]);
        this.cancel();
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.errorInfo = '';

    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    }
    else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
      this.salescategoryCd = new FormControl('', [
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.code39),
        Validators.maxLength(validation.salescategoryCd.maxLength)
      ]);
      this.salescategoryTx = new FormControl('', [
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.salescategoryTx.maxLength)
      ]);
      this.creditaccCd = new FormControl('', [
        Validators.pattern(validation.halfBlankOnly),
        Validators.pattern(validation.code39),
        Validators.maxLength(validation.creditaccCd.maxLength)
      ]);
    }
  }

  ngDoCheck() {
    if (this.salescategoryCd.value !== '' && this.salescategoryTx.value !== '' && this.creditaccCd.value !== '') {
      this.isSubmitButtonEnabled = true;
    } else {
      this.isSubmitButtonEnabled = false;
    }
  }

  initDatas() {
    this.errorInfo = '';
    var salescategoryCd = '';
    var salescategoryTx = '';
    var creditaccCd = '';

  }

  clrErr() {
    this.errorInfo = '';
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9161/wa9161.component.ts